module.exports = __webpack_public_path__ + "img/hubFindr.png.494fdbfc.webp";